module.exports = __webpack_public_path__ + "static/media/excellency.e475ca03.jpeg";